document.addEventListener('rebuy:cart.add', (event) => { 
  // console.log('rebuy:cart.add event', event.detail); 

  let productHandle = event.detail.item.handle;

  if(handleCompletetheLook === productHandle){
    if ($('div#myModalCompleteLook').length) {
      $("#openModal").click();
      $("div#myModalCompleteLook #message-add-to-cart").fadeIn();
      $("div#myModalCompleteLook").addClass('open-modal-rebuy');
    }
  };
  
});